import type {Options, Plugin} from 'intl-tel-input';
import intlTelInput from 'intl-tel-input';

export const phoneInput = (input: Element, options: Options): Plugin =>
  intlTelInput(input, options);
